var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002453(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0551758,
    y: 0.317383,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_1083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9417 22.5733C32.9297 24.1358 31.6591 25.4144 30.0966 25.4357C29.6886 25.4411 29.3006 25.3624 28.9473 25.2144C28.5607 25.0531 28.134 25.3357 28.134 25.7544V30.8474C28.134 31.1714 27.8714 31.4327 27.5487 31.4327H14.0256C12.0084 31.4327 10.3726 29.7968 10.3726 27.7796V14.2565C10.3726 13.9325 10.6352 13.6712 10.9579 13.6712H15.8869C16.2682 13.6712 16.5535 13.3125 16.4588 12.9432C16.3975 12.7046 16.3668 12.4539 16.3695 12.1953C16.3882 10.6301 17.6667 9.35681 19.232 9.34481C20.7972 9.33281 22.1371 10.6287 22.1371 12.2286C22.1371 12.4726 22.1064 12.7113 22.0491 12.9379C21.9558 13.3099 22.2331 13.6712 22.6157 13.6712H27.5487C27.8727 13.6712 28.134 13.9338 28.134 14.2565V19.3508C28.134 19.7708 28.562 20.0494 28.9486 19.8881C29.29 19.7468 29.6633 19.6681 30.0566 19.6681C31.6565 19.6681 32.9524 20.9707 32.9404 22.5733H32.9417Z",
    fill: "url(#paint0_linear_1352_1083)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1083",
    x1: 25.2037,
    y1: 9.34473,
    x2: 13.9191,
    y2: 31.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2399FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7756E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_1083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5692,
    height: 22.0879,
    fill: "white",
    transform: "translate(10.3726 9.34473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002453);
export default __webpack_public_path__ + "static/media/Group-1000002453.20b3fe3547a405a8ba681d247141b093.svg";
export { ForwardRef as ReactComponent };